import { memo } from 'react';

import { Trash2Icon } from 'lucide-react';

import { TableCell, TableRow, Text } from '@/_components';
import { ActionButton } from '@/_containers/actions';
import { formatFileSize } from '@/_shared';

import { FilePreview } from './file-preview';

interface UploadFileRowProps {
  file: File;
  fileUrl?: string;
  onRemove?: (fileName: string) => void;
  disabled: boolean;
}

function UploadFileRowComponent({ file, fileUrl, onRemove, disabled }: UploadFileRowProps) {
  return (
    <TableRow>
      <TableCell className="px-2 whitespace-nowrap">
        <div className="flex items-center">
          <FilePreview filename={file.name} fileUrl={fileUrl} mimeType={file.type} />
          <div className="ml-4 flex flex-col">
            <Text className="text-c-card-muted max-w-[200px] overflow-hidden break-all text-ellipsis">{file.name}</Text>
            <Text className="text-xs text-gray-500">{file.type}</Text>
          </div>
        </div>
      </TableCell>
      <TableCell className="px-2 text-right text-sm whitespace-nowrap text-gray-500">
        {formatFileSize(file.size)}
      </TableCell>
      <TableCell className="px-2 text-right text-sm whitespace-nowrap">
        {!disabled && onRemove && (
          <ActionButton
            size="sm"
            title="Remove File"
            tag="button"
            icon={Trash2Icon}
            type="icon"
            onClick={() => onRemove(file.name)}
          />
        )}
      </TableCell>
    </TableRow>
  );
}

export const UploadFileRow = memo(UploadFileRowComponent);
